import React from 'react';
import PageShell from '../ui/PageShell';
import { PageHeader } from '../ui/PageHeader';
import { NotificationPreferences } from './NotificationCenter';
import PageBackLink from '../ui/PageBackLink';
import SettingsSubnav from '../settings/SettingsSubnav';

/**
 * Full-page preference center for notifications and email categories.
 * Mounted at NOTIFICATION_PREFERENCES_PATH (/settings/notifications).
 */
const NotificationPreferencesPage: React.FC = () => (
  <PageShell>
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <PageBackLink label="Back to Settings" to="/settings" className="mb-4" />
      <PageHeader
        eyebrow="Settings"
        title="Notifications and email"
        description="Organize updates by what you care about. Account and security messages stay on."
      />
      <SettingsSubnav />
      <NotificationPreferences />
    </div>
  </PageShell>
);

export default NotificationPreferencesPage;
